import { useRef, useState } from 'react';
import Button from './Button'
import { set } from 'date-fns';
import ApiException from '../../types/ApiException';

interface FileUploadButtonArgs {
    chooseButtonText: string,
    showRemoveButton: boolean,
    removeButtonText: string,
    acceptedFileTypes?: string, //accept="file_extension|audio/*|video/*|image/*|media_type"
    onFileChange: (file: File | null) => void,
    className?: string,
    removeButtonClassName?: string,
    startIcon?: string,
    primary?: boolean,
    tertiary?: boolean,
    disabled?: boolean,
    err: ApiException | null,
    errField: string,
}

const FileUpload = ({ chooseButtonText, removeButtonText, showRemoveButton = false, acceptedFileTypes = "*", onFileChange, className, removeButtonClassName, startIcon = "upload", primary, tertiary, disabled, err, errField }: FileUploadButtonArgs) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const hiddenFileInput = useRef<HTMLInputElement>(null);
    const [showRemoveButtonState, setShowRemoveButtonState] = useState(showRemoveButton);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (hiddenFileInput && hiddenFileInput.current)
            hiddenFileInput.current.click();

        event.preventDefault();
    };

    const onInputFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log("thumbnail upload click, event.target: ", event.target);
        if (event.target.files && event.target.files.length > 0) {
            //setThumbnail(URL.createObjectURL(event.target.files[0]));
            const file = event.target.files[0];
            setSelectedFile(file);
            setShowRemoveButtonState(true);
            onFileChange(file);
        }
        // setFormValues((prevFormValues) => ({
        //   ...prevFormValues,
        //   image: event.target.files ? event.target.files[0] : null,
        // }));
    };

    const onRemoveFile: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        console.log("thumbnail remove click, event: ", e);
        if (hiddenFileInput.current)
            hiddenFileInput.current.value = '';

        setSelectedFile(null);
        setShowRemoveButtonState(false);
        onFileChange(null);
        e.preventDefault();
    };

    return (
        <>
            <Button disabled={disabled} primary={primary} tertiary={tertiary} startIcon={startIcon} className={className} onClick={handleClick}>
                {chooseButtonText}
            </Button>
            {showRemoveButton && <Button primary onClick={onRemoveFile} className={removeButtonClassName}>{removeButtonText}</Button>}
            <input onChange={onInputFileChange} type="file" ref={hiddenFileInput} style={{ display: "none" }} accept={acceptedFileTypes} />
            {err && err.ValidationErrors && err.ValidationErrors[errField] &&
                <span className="error red">{err.ValidationErrors[errField]}</span>
            }
        </>
    )
}

export default FileUpload